import { Grid, Box } from '@mui/material';

const Title = ({ title, unitDesc }) => {
  return (
    <Grid container>
      <Grid item xs={6} style={{ fontSize: '1rem', fontWeight: 'bold' }}>
        {title}
      </Grid>
      <Grid
        item
        xs={6}
        sx={{
          display: 'flex',
          flexDirection: 'row-reverse',
          textAlign: 'right',
        }}
      >
        <Box
          sx={{
            alignSelf: 'flex-end',
            fontSize: '0.8rem',
          }}
        >
          {unitDesc}
        </Box>
      </Grid>
    </Grid>
  );
};

export default Title;
